import { render, staticRenderFns } from "./BillDetail.vue?vue&type=template&id=ac8df844"
import script from "./BillDetail.vue?vue&type=script&lang=ts"
export * from "./BillDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports